import React from 'react'
import { CardMedia, CardHeader, makeStyles } from '@material-ui/core'
import { alpha } from '@material-ui/core/styles/colorManipulator'
import PropTypes from 'prop-types'
import useEntity from 'hooks/useEntity'

const useStyles = makeStyles((theme) => ({
  image: {
    paddingTop: '66.66%' // 3:2 aspect ratio
  },
  titleScrim: {
    backgroundColor: alpha(theme.palette.grey[900], 0.5),
    position: 'absolute',
    left: '0px',
    top: '0px',
    width: '100%',
    color: theme.palette.common.white
  }
}))

export default function TopSection({ id }) {
  const { photoUrl, name } = useEntity('campaigns', id)
  const classes = useStyles()

  return (
    <React.Fragment>
      <CardHeader className={classes.titleScrim} titleTypographyProps={{ variant: 'body1', component: 'h3' }} title={name} />
      <CardMedia image={photoUrl} title={name} className={classes.image} />
    </React.Fragment>
  )
}

TopSection.propTypes = {
  id: PropTypes.string.isRequired,
}
